export const FILTER_REGEX = [/token/gi, /encrypted/gi];

// for some reason, regex filter is not removing refreshToken
// referrer includes full url which could contain user specific token
export const FILTER_STRINGS = ['refreshToken', 'Referer'];
